module.exports = "/_next/static/images/ch-efb7dd839c4e99bcc1de44057eb68b25.svg";